export { default as Icon } from './Icon'



// WEBPACK FOOTER //
// ./src/app/elements/Icon/index.js